import React, { Component } from "react"
import { Pagination } from "antd"

import { getAllRaces } from "../api/async/index"
import { RaceCard } from "../components/RaceCard/index"
import { endRegisterRace } from "../utils/index"

class PastRaces extends Component {
  state = {
    closeRaces: [],
    showCloseRaces: []
  }

  componentWillMount = async () => {
    const races = await getAllRaces()
    this.setState({ races: races.data })
    document.title = "Run24Hrs - Virtual Run - งานวิ่งทั้งหมด"
    const closeRaces = this.state.races.filter(each => endRegisterRace(each))
    this.setState({ closeRaces })
    this.setState({ showCloseRaces: closeRaces.slice(0, 5) })
  }

  handlePaginateChange = offset => {
    this.setState({
      showCloseRaces: this.state.closeRaces.slice((offset - 1) * 5, offset * 5)
    })
  }

  render() {
    return (
      <React.Fragment>
        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
            marginBottom: "10px"
          }}
        >
          <h1 className="mobile-h1">งานวิ่งที่ผ่านมา</h1>
        </div>
        {this.state.showCloseRaces.map(each => (
          <div className="column">
            <RaceCard race={each} />
          </div>
        ))}
        <Pagination
          style={{ textAlign: "center" }}
          defaultCurrent={1}
          defaultPageSize={5}
          total={this.state.closeRaces.length}
          onChange={(pageXOffset, _) => this.handlePaginateChange(pageXOffset)}
        />
      </React.Fragment>
    )
  }
}

export default PastRaces



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/PastRaces.js